import { inject, provide } from 'vue';

import type { InjectionKey } from 'vue';

export const CdsMainSymbol: InjectionKey<boolean> = Symbol('cds:main');

export const useProvideMain = (provided: boolean) => {
  provide(CdsMainSymbol, provided);
};

export const useInjectMain = () => {
  return inject(CdsMainSymbol, false);
};
